import angular from "angular";

angular
    .module('accessControlCrud.permission', [])
    .service('Permission', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/permissions';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.delete = function (id) {
            return $http.post(uri(id), {'_method': 'DELETE'});
        };

    }]);

export default 'accessControlCrud.permission';


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/permission.js